import React from "react"
import Label from "../Label"
import I18n from "i18n"

export default (props: any) => (
  <Label label={I18n.t("title_seller_orders_history_tab")} {...props} />
)
